module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-padding"
  }, [_c('h3', {
    staticClass: "mg-clear tc-outer-space"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider-h"
  }, [_c('span', {
    staticClass: "divider"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-214484d3"}!./src/app/components/quote-preview-section/quote-preview-section.html
// module id = 464
// module chunks = 1